import { searchAddressComponentByPostalCode } from "../../../utils/yubinbango";
import TextField from "@mui/material/TextField";
import React from "react";

export default function AddressCell(props) {
  const { rowData, handleChange } = props;

  const handleChangePostalCode = (newValue) => {
    if (typeof newValue !== "string") return;
    const postalCode = newValue.replaceAll(/[^0-9]/g, "");
    handleChange('customerPostalCode', postalCode, rowData)
    if (!postalCode || postalCode.length !== 7) return;

    searchAddressComponentByPostalCode(postalCode).then((res) => {
      let address = ''
      if (res.region) {
        address = (res.region || "") + (res.locality || "") + (res.street || "")
        if (res.extended)
          address += (res.extended || "")
      }

      handleChange('customerAddress', address || '', rowData)
    });
  };

  return (
    <>
      {rowData.showInput ? (
        <div className="flex-1 h-full w-[75%]">
          <div className="">
            <TextField
              InputProps={{
                style: {
                  borderRadius: "10px",
                },
              }}
              value={rowData.detail.customerPostalCode}
              onChange={(newValue) => {
                handleChange('customerAddress', '', rowData);
                handleChangePostalCode(newValue.target.value);
              }}
              size="small"
              className="w-full"
              inputProps={{ maxLength: 7 }}
            />
          </div>
          <div>
            <TextField
              InputProps={{
                style: {
                  borderRadius: "10px",
                },
              }}
              value={rowData.detail.customerAddress}
              onChange={(newValue) =>
                handleChange('customerAddress', newValue.target.value)
              }
              size="small"
              className="w-full"
            />
          </div>
        </div>
      ) : (
        <div
          className="h-full w-[75%] border border-[#B3B3B3] bg-[#B3B3B3] bg-opacity-[26%] px-0 py-[10px] text-sm"
          style={{
            flex: 1,
            textAlign: rowData.textAlign || "start",
          }}
        >
          <p className="leading-[18px] pl-4 tracking-[1.75px] truncate">
            {rowData.detail.customerPostalCode || "-"}
          </p>
          <div className="border border-[#B3B3B3] border-dashed m-2"></div>
          <p className="leading-[18px] pl-4 tracking-[1.75px] truncate">
            {rowData.detail.customerAddress || "-"}
          </p>
        </div>
      )}
    </>
  );
}